import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Box, Typography } from '@mui/material';
import React from 'react';

export const SuccessState: React.FC = () => {
  return (
    <Box
      sx={{
        py: 6,
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 1.5,
      }}
    >
      <CheckCircleIcon sx={{ fontSize: 48, color: '#10b981' }} />
      <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#111827' }}>
        Bug report submitted!
      </Typography>
      <Typography variant="body2" sx={{ color: '#6b7280', maxWidth: 260 }}>
        Thank you! Our engineering team will review the details and investigate.
      </Typography>
    </Box>
  );
};
